import { Typography } from "@mui/material";
import { type FC } from "react";

import { ActionButtons } from "~/feature/event/components/ActionButtons";
import { EventDateRange } from "~/feature/event/components/EventDateRange";
import { EventMetrics } from "~/feature/event/components/EventMetrics";
import { EventTags } from "~/feature/event/components/EventTags";
import { EventPageSections } from "~/feature/event/constants";
import type { IAggregatedEvent } from "~/types/event";

import * as Styled from "./EventHeader.styles";

interface IEventHeaderProps {
  event: IAggregatedEvent;
}

export const EventHeader: FC<IEventHeaderProps> = ({ event }) => {
  return (
    <Styled.Root component="section" id={EventPageSections.EventHeader}>
      {event.imageUrl ? (
        <Styled.EventIcon src={event.imageUrl} alt={event.title} />
      ) : null}
      <Styled.ContentBox>
        <Styled.InnerStack>
          <Styled.TitleStack>
            <Styled.TitleRow>
              <EventTags
                tags={event.tags}
                categoryId={event.category || ""}
                platforms={event.platforms}
              />
              <ActionButtons event={event} />
            </Styled.TitleRow>
            <Typography component="h1" variant="h5" sx={{
              fontWeight: "700"
            }}>
              {event.seo.seoH1 || event.title}
            </Typography>
            <EventDateRange event={event} />
          </Styled.TitleStack>
          <EventMetrics event={event} />
        </Styled.InnerStack>
      </Styled.ContentBox>
    </Styled.Root>
  );
};
